<template>
  <div class="popup-main">
    <el-dialog
      title="选择订单"
      width="1240px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <el-form class="flex m-b-10" @submit.native.prevent="searchListData">
          <el-input
            style="width: 240px"
            size="mini"
            placeholder="请输入销售单号/客户名称/业务员"
            v-model="keyword"
            clearable
            @clear="searchListData"
          />
          <el-button
            class="m-l-10"
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="searchListData"
          >
            搜索
          </el-button>
        </el-form>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          size="mini"
          show-footer
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 360"
          :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
          :keyboard-config="{ isArrow: true }"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_default -->
          <template #default_status_str="{ row }">
            <el-tag size="mini" :type="getStatusType(row.status_str)">
              {{ row.status_str }}
            </el-tag>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupPush">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      loading: true,
      keyword: '',

      // filter
      filterData: {
        // status_str: '进行中'
      },
      sortData: {
        bill_id: 'desc'
      },

      // table
      tableData: [],
      tableColumn: [
        {
          fixed: 'left',
          type: 'radio',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '销售日期',
          field: 'bill_date',
          width: 100
        },
        {
          title: '销售单号',
          field: 'bill_code',
          width: 100
        },
        {
          title: '客户名称',
          field: 'company_name'
        },
        {
          title: '业务员',
          field: 'saler_name'
        },

        {
          title: '订单金额(元)',
          field: 'sales_amount_total'
        },
        {
          title: '备注',
          field: 'bill_remark'
        },
        {
          title: '状态',
          slots: { default: 'default_status_str' }
        }
      ],
      statusList: [
        {
          key: '全部',
          val: '全部',
          type: 'info'
        },
        {
          key: '待审核',
          val: '待审核',
          type: 'warning'
        },
        {
          key: '已驳回',
          val: '已驳回',
          type: 'danger'
        },
        {
          key: '进行中',
          val: '进行中',
          type: 'primary'
        },
        {
          key: '已完结',
          val: '已完结',
          type: 'success'
        },
        {
          key: '已作废',
          val: '已作废',
          type: 'info'
        },
        {
          key: '暂存',
          val: '暂存',
          type: 'info'
        }
      ],
      pageOptions: {
        ...this.$constant.page
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getListData()
  },
  methods: {
    // 获取状态类型
    getStatusType(val) {
      let result = ''
      this.statusList.forEach((item) => {
        if (item.val === val) result = item.type
      })
      return result
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/checkBill2/list',
        data: {
          // bill_status1: '订单',
          bill_status2: '创建',
          keyword: this.keyword,
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          filterData: this.filterData,
          sortData: this.sortData
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            this.tableData = data.list
            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getRadioRecord() {
      return this.$refs.refTable.getRadioRecord()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setRadioRow(params.row) // 选中radio
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowRadio = this.$refs.refTable.isCheckedByRadioRow(row)
        if (isCurrentRowRadio) {
          this.$refs.refTable.clearRadioRow() // 清空radio
        } else {
          this.$refs.refTable.setRadioRow(row) // 选中radio
        }
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupPush() {
      let row = this.getRadioRecord()
      if (row) {
        this.$emit('success', this.$util.deepCopy(row))
      } else {
        this.itemChoosePrompt()
        return
      }
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
